<template src="./review-flow-footer.html"></template>

<script lang="ts">


export default {
  props: {
    texts: Array // array of strings (paragrapshs)
  }
}
</script>

<style lang="scss" src="./review-flow-footer.scss"></style>
